<template>
  <div class="app_container">
    <!--操作栏-->
    <div class="filter_container">
      <butn
        btntype="primary"
        title="新增"
        iconName="el-icon-plus"
        v-permission="'periodicalInfo:save'"
        @click="$router.push('periodicalInfo/add')"
      ></butn>
      <butn
        v-permission="'periodicalInfo:share'"
        :disabled="selections.length === 0"
        title="共享"
        @click="oneClickShare"
      ></butn>
      <!-- <butn
        v-permission="'periodicalInfo:shareAll'"
        @click="oneClickShare"
        :disabled="selections.length > 0"
        title="一键共享"
      ></butn> -->
      <!--工具栏-->
      <div class="search_right">
        <Search @search="searchHandle" />
      </div>
    </div>
    <!--表格内容栏-->
    <Tables @selection-change="selectionChange" :data="periodicalInfoList" />
    <!--分页栏-->
    <div class="RCPagination">
      <RCPagination ref="pagination" v-model="periodicalInfoList" :api="api" />
    </div>
    <!-- 详情 -->
    <Details />
    <periodicalSubject></periodicalSubject>
    <cmCurd></cmCurd>
    <!-- 期次管理 -->
    <periodicalPeriod></periodicalPeriod>
    <pmCurd></pmCurd>
    <share-manage></share-manage>
    <one-click-share></one-click-share>
  </div>
</template>
<script>
import Search from "./search";
import RCPagination from "@/components/pagination/paginationManage";
import butn from "@/components/button/index";
import Tables from "./table.js";
import Bus from "./Bus.js";
import PeriodicalSubject from "./columnManage/index";
import Details from "./details";
import cmCurd from "./columnManage/curd";
import OneClickShare from "./oneClickShare/index";
import periodicalPeriod from "./periodManage/index";
import ShareManage from "./share/index";
import pmCurd from "./periodManage/curd";
import {
  periodicalInfoList,
  periodicalInfoDelete,
  changeOnlineStatus,
} from "@/api/periodicalInfo";
import { getItem, removeItem } from "@/utils/storage.js";

export default {
  name: "periodicalInfo",
  activated() {
    if (getItem(this.REFRESH_FLAG)) {
      this.$refs["pagination"].search(this.dataname);
      removeItem(this.REFRESH_FLAG);
    }
  },
  components: {
    Tables,
    butn,
    Search,
    RCPagination,
    PeriodicalSubject,
    Details,
    cmCurd,
    periodicalPeriod,
    OneClickShare,
    ShareManage,
    pmCurd,
  },
  data() {
    return {
      size: "small",
      filters: {
        name: "",
      },
      periodicalInfoList: [],
      api: periodicalInfoList,
      selections: [], // 列表选中列
      dialogFormVisible: false,
      dataname: "",
    };
  },
  mounted() {
    Bus.$on("reload", () => {
      this.$refs["pagination"].search(this.dataname);
    });
  },
  beforeDestroy() {
    Bus.$off("reload");
  },
  methods: {
    handleAdd() {
      Bus.$emit("ReceiveMessage", "");
    },
    selectionChange: function (selections) {
      this.selections = selections;
    },
    //上下线
    changeOnlineStatus(data, status) {
      this.$confirm(
        `${status == 1 ? "确认要上线该期刊吗?" : "确认要下线该期刊吗？"}`,
        "系统提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          changeOnlineStatus({ uuids: [data.uuid], onlineStatus: status })
            .then((res) => {
              if (res && res.code == 0) {
                this.$message.success(res.msg);
                // 带上历史条件更新列表
                this.$refs["pagination"].search(this.dataname);
                // Bus.$emit("ReceiveMessage", "123");
              }
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    //删除
    deleteData(data) {
      this.$confirm(`确认要删除该期刊吗?`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          periodicalInfoDelete({ uuids: [data.uuid] })
            .then((res) => {
              if (res && res.code == 0) {
                this.$message.success(res.msg);
                // 带上历史条件更新列表
                this.$refs["pagination"].search(this.dataname);
                // Bus.$emit("ReceiveMessage", "123");
              }
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    //搜索
    searchHandle(data) {
      this.dataname = { ...data };
      this.$refs["pagination"].search(this.dataname);
    },
    oneClickShare() {
      Bus.$emit("oneClickShare", this.periodicals);
    },
  },
  created() {
    var _this = this;
    Bus.$on("deleteperiodicalInfo", function (item) {
      _this.deleteData(item);
    });
    Bus.$on("upLine", function (item) {
      _this.changeOnlineStatus(item, 1);
    });
    Bus.$on("downLine", function (item) {
      _this.changeOnlineStatus(item, 0);
    });
  },
  computed: {
    periodicals() {
      return this.selections.map((item) => item.uuid);
    },
  },
};
</script>
